export default __webpack_public_path__ + "static/media/Mission.01b8141a.png";